import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { formatDuration, moneyFormat } from "../../../Utils"

export default function ServiceOrderServiceInfoModal({
    service,
    open,
    closeModal
}) {

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                maxWidth={'sm'}
                fullWidth
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>{service?.name}{" Info"}</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container direction='column' sx={{ width: '100%' }}>
                        <Grid>
                            <span>Service Kit: {service?.service_kit?.name}</span>
                        </Grid>
                        <Grid>
                            <span>Description: {service?.service_kit?.description}</span>
                        </Grid>
                        <h3>Default Pricing</h3>
                        <Grid container spacing={3}>
                            <Grid container direction="column" sx={{ textAlign: 'right' }} size={6}>
                                <Grid>
                                    <span>Flat Rate Cost</span>
                                </Grid>
                                <Grid>
                                    <span>Hourly Rate</span>
                                </Grid>
                                <Grid>
                                    <span>Part Costs</span>
                                </Grid>
                            </Grid>
                            <Grid container direction="column" sx={{ textAlign: 'right' }} size={6}>
                                <Grid>
                                    <span>${moneyFormat(service.default_flat_rate)}</span>
                                </Grid>
                                <Grid>
                                    <span>{formatDuration(service.default_minutes_worked)} hrs @ ${moneyFormat(service.default_hourly_rate)} / hr</span>
                                </Grid>
                                <Grid>
                                    <span>{service.part_price_adjustment === -100 ?
                                        "$0 (INCLUDED)"
                                        :
                                        service.part_price_adjustment === 0 ?
                                            `At Cost`
                                            :
                                            `${service.part_price_adjustment > 0 ? '+' : ''}${service.part_price_adjustment}%`
                                    }</span>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={closeModal}>
                                {"Close"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
